// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../root/.nvm/versions/node/v25.9.0/lib/node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../root/.nvm/versions/node/v25.9.0/lib/node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset some default styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* Container styling */
form {
  max-width: 600px;
  margin: 40px auto;
  padding: 25px 30px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

/* Headings */
h4 {
  margin-bottom: 15px;
  color: #333;
  text-align: center;
}

h5 {
  margin-bottom: 10px;
  color: #555;
}

/* Paragraph text */
p {
  font-size: 14px;
  color: #777;
  margin-bottom: 15px;
}

/* Labels */
label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  color: #444;
}

/* Inputs, textarea, select */
input,
textarea,
select {
  width: 100%;
  padding: 10px 12px;
  margin-bottom: 18px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
}

/* Focus effect */
input:focus,
textarea:focus,
select:focus {
  border-color: #4a90e2;
  outline: none;
  box-shadow: 0 0 5px rgba(74, 144, 226, 0.4);
}

/* Textarea resize */
textarea {
  min-height: 100px;
  resize: vertical;
}
/* Background */
body {
  background: linear-gradient(135deg, #667eea, #764ba2);
  min-height: 100vh;
}

/* Headings */
h4 {
  margin-bottom: 15px;
  color: #fff;
  text-align: center;
  font-size: 22px;
}

h5 {
  margin-bottom: 10px;
  color: #f1f1f1;
}

/* Paragraph */
p {
  font-size: 14px;
  color: #e0e0e0;
  margin-bottom: 15px;
}

/* File input */
input[type="file"] {
  padding: 6px;
  background-color: #f9f9f9;
}

/* Button styling */
button {
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, #4a90e2, #357abd);
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
}

/* Button hover */
button:hover {
  background: linear-gradient(135deg, #357abd, #2c5f9e);
  transform: translateY(-2px);
}

/* Note text */
form p:last-child {
  font-size: 12px;
  color: #999;
  text-align: center;
  margin-top: 10px;
}

/* Responsive design */
@media (max-width: 768px) {
  form {
    margin: 20px;
    padding: 20px;
  }

  h4 {
    font-size: 18px;
  }

  button {
    font-size: 15px;
  }
}

/* Extra small devices */
@media (max-width: 480px) {
  input,
  textarea,
  select {
    font-size: 13px;
    padding: 8px;
  }

  button {
    padding: 10px;
  }
}



/* Wrapper */
.file-upload {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}

/* Hide default input */
.file-upload input[type="file"] {
  display: none;
}

/* Custom button */
.file-label {
  background: linear-gradient(135deg, #e85492, #ff758c);
  color: #fff;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: 0.3s;
}

.file-label:hover {
  opacity: 0.9;
}

/* File name text */
.file-name {
  font-size: 14px;
  color: #eae9e9;
}



/*    responsive   web  */
@media (max-width: 768px) {

  /* Stack flex items vertically, reduce padding/margins, smaller fonts */
  .container {
    flex-direction: column;
    padding: 16px;
  }

  h1 {
    font-size: 1.5rem;
  }

  img {
    max-width: 100%;
    height: auto;
  }
}

@media (max-width: 480px) {

  /* Further reductions for phones */
  .nav-bar {
    font-size: 20px;
    padding: 4px 8px;
  }

  .intro-box {
    padding: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Internship.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,4DAA4D;AAC9D;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qDAAqD;EACrD,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA,6BAA6B;AAC7B;;;EAGE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;;;EAGE,qBAAqB;EACrB,aAAa;EACb,2CAA2C;AAC7C;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA,eAAe;AACf;EACE,qDAAqD;EACrD,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,wBAAwB;AACxB;EACE;;;IAGE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;;;AAIA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,qDAAqD;EACrD,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,cAAc;AAChB;;;;AAIA,yBAAyB;AACzB;;EAEE,uEAAuE;EACvE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;;EAEE,kCAAkC;EAClC;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Reset some default styles */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n/* Container styling */\nform {\n  max-width: 600px;\n  margin: 40px auto;\n  padding: 25px 30px;\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  border-radius: 12px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n}\n\n/* Headings */\nh4 {\n  margin-bottom: 15px;\n  color: #333;\n  text-align: center;\n}\n\nh5 {\n  margin-bottom: 10px;\n  color: #555;\n}\n\n/* Paragraph text */\np {\n  font-size: 14px;\n  color: #777;\n  margin-bottom: 15px;\n}\n\n/* Labels */\nlabel {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 600;\n  color: #444;\n}\n\n/* Inputs, textarea, select */\ninput,\ntextarea,\nselect {\n  width: 100%;\n  padding: 10px 12px;\n  margin-bottom: 18px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.3s ease;\n}\n\n/* Focus effect */\ninput:focus,\ntextarea:focus,\nselect:focus {\n  border-color: #4a90e2;\n  outline: none;\n  box-shadow: 0 0 5px rgba(74, 144, 226, 0.4);\n}\n\n/* Textarea resize */\ntextarea {\n  min-height: 100px;\n  resize: vertical;\n}\n/* Background */\nbody {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  min-height: 100vh;\n}\n\n/* Headings */\nh4 {\n  margin-bottom: 15px;\n  color: #fff;\n  text-align: center;\n  font-size: 22px;\n}\n\nh5 {\n  margin-bottom: 10px;\n  color: #f1f1f1;\n}\n\n/* Paragraph */\np {\n  font-size: 14px;\n  color: #e0e0e0;\n  margin-bottom: 15px;\n}\n\n/* File input */\ninput[type=\"file\"] {\n  padding: 6px;\n  background-color: #f9f9f9;\n}\n\n/* Button styling */\nbutton {\n  width: 100%;\n  padding: 12px;\n  background: linear-gradient(135deg, #4a90e2, #357abd);\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n/* Button hover */\nbutton:hover {\n  background: linear-gradient(135deg, #357abd, #2c5f9e);\n  transform: translateY(-2px);\n}\n\n/* Note text */\nform p:last-child {\n  font-size: 12px;\n  color: #999;\n  text-align: center;\n  margin-top: 10px;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  form {\n    margin: 20px;\n    padding: 20px;\n  }\n\n  h4 {\n    font-size: 18px;\n  }\n\n  button {\n    font-size: 15px;\n  }\n}\n\n/* Extra small devices */\n@media (max-width: 480px) {\n  input,\n  textarea,\n  select {\n    font-size: 13px;\n    padding: 8px;\n  }\n\n  button {\n    padding: 10px;\n  }\n}\n\n\n\n/* Wrapper */\n.file-upload {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n/* Hide default input */\n.file-upload input[type=\"file\"] {\n  display: none;\n}\n\n/* Custom button */\n.file-label {\n  background: linear-gradient(135deg, #e85492, #ff758c);\n  color: #fff;\n  padding: 10px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: 0.3s;\n}\n\n.file-label:hover {\n  opacity: 0.9;\n}\n\n/* File name text */\n.file-name {\n  font-size: 14px;\n  color: #eae9e9;\n}\n\n\n\n/*    responsive   web  */\n@media (max-width: 768px) {\n\n  /* Stack flex items vertically, reduce padding/margins, smaller fonts */\n  .container {\n    flex-direction: column;\n    padding: 16px;\n  }\n\n  h1 {\n    font-size: 1.5rem;\n  }\n\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n@media (max-width: 480px) {\n\n  /* Further reductions for phones */\n  .nav-bar {\n    font-size: 20px;\n    padding: 4px 8px;\n  }\n\n  .intro-box {\n    padding: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
